export const PRINTER_DETAILS = [
  'paper_low', 'paper_out', 'cover_open', 'cutter_error', 'overheat', 'mechanical_error', 'unrecoverable_error', 'printer_error',
  'offline', 'not_answering', 'not_found', 'ambiguous', 'transport_unsupported', 'write_failed', 'write_timeout', 'slip_failed', 'job_timeout',
] as const;

export function printerDetailLabel(translate: (key: string) => string, detail: string): string {
  return (PRINTER_DETAILS as readonly string[]).includes(detail) ? translate(`resources.kiosk-devices.printerDetail.${detail}`) : detail;
}
